import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import styled from '@emotion/styled'
import Breadcrumb from '../../components/common/Breadcrumb'
import EClaimInfo from '../EClaimDetail/EClaimInfo'
import { useRouter } from '../../utils/helper'
import { useGetEClaimById } from '../../services/e-claim/e-claim-query'
import { home } from '../../constant/path'
import { pullAt } from 'lodash'
import { useScreen } from '../../utils/responsive-helper'
import Headbar from '../../components/common/HeadBar'
import { exerciseDetail } from '../../constant/path'
import { useTranslation } from 'react-i18next'
import { mobile } from '../../utils/responsive-helper'
import { useGetExerciseById } from '../../services/exercise/exercise-query'
import ExerciseForm from './ExerciseForm'
import color from '../../constant/colors'
import { ExerciseInfoWithConcentDate, ExerciseInfoWithoutConcentDate } from '../../redux-store/exercise-reducer'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const ExerciseSummary = () => {
  const { query } = useRouter<{ exerciseId: number }>()
  const { t } = useTranslation()
  const { isMobile } = useScreen()
  const { data: exerciseItem, isLoading } = useGetExerciseById({ claimId: query.exerciseId })

  const ExerciseFormValue = useSelector((state: RootState) => state.exercise.ExerciseInfo) as ExerciseInfoWithoutConcentDate & ExerciseInfoWithConcentDate
  console.log({ ExerciseFormValue })
  return (
    <>
      <BackgroundHeader />
      <Layout>
        <Headbar title={exerciseItem?.name || ''} backWard={exerciseDetail({ routeParam: { exerciseId: query.exerciseId } })} />
        {/* <EClaimInfo eClaimItem={eClaimItem} editable={false} /> */}
        <ExerciseForm
          exerciseItem={exerciseItem}
          exerciseId={query.exerciseId}
          exerciseFormValue={ExerciseFormValue}
          editable={false}
          isPreview={true}
        />
      </Layout>
    </>
  )
}

export default ExerciseSummary
